<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>产品技术服务</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                                @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <div class="about-header">
    <h3>产品列表</h3>
    <el-button type="primary" size="mini" @click="showAllProducts">展示所有产品</el-button>
</div>
                        <el-divider></el-divider>
                        <el-table :data="productList" style="width: 100%" @row-click="goToDetail">
                            <el-table-column prop="unitName" label="公司名称"></el-table-column>
                            <el-table-column prop="productName" label="产品名称"></el-table-column>
                            <el-table-column prop="website" label="官网地址">
                                <template slot-scope="scope">
                                    <a :href="scope.row.website" target="_blank">{{ scope.row.website }}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="创建日期"></el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <div class="pages">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                                layout="prev, pager, next" :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                productList: [],
                total: 0,
                isActive: 1, // '产品列表' is the active one
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                },
                list: [{
                        text: '产品公司列表',
                        id: 1
                    },
                    {
                        text: '产品列表',
                        id: 2
                    }
                ]
            }
        },
        mounted() {
            if (this.$route.query.productName) {
                this.queryParams.productName = this.$route.query.productName;
            }
            this.getProductList();
        },
        methods: {
            getProductList() {
                this.$axios.get('/business/getProductList', { params: this.queryParams }).then(res => {
                    if (res.data.rows) {
                        this.productList = res.data.rows;
                        this.total = res.data.total;
                    }
                }).catch(error => {
                    console.error('获取产品列表失败:', error);
                });
            },
            handleSizeChange(row) {
                this.queryParams.pageSize = row;
                this.getProductList();
            },
            handleCurrentChange(row) {
                this.queryParams.pageNum = row;
                this.getProductList();
            },
            listClick(id, index) {
                this.isActive = index;
                if (id == 1) {
                    this.$router.push({
                        path: '/companyList',
                    });
                } else if (id == 2) {
                    // already here
                }
            },
            showAllProducts() {
                this.queryParams.productName = undefined;
                this.getProductList();
            },
            goToDetail(row) {
                this.$router.push({
                    name: 'ProductDetail',
                    params: { productId: row.id }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        line-height: 20px;
                        text-align: justify;

                        .about-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

h3 {
                            font-size: 18px;
                            color: #066FC4;
                            margin-bottom: 10px;
                        }
                        .pages {
                            padding: 20px 0;
                            display: flex;
                            justify-content: center;
                        }
                    }
                }
            }
        }
    }
    .el-table__row {
        cursor: pointer;
    }
</style>